// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SpectralChannelsFieldNext-styles_checkbox__1iFgR","bandColoredBox":"SpectralChannelsFieldNext-styles_bandColoredBox__1LWPf"};